import React from "react";
import { Link } from "react-router-dom";
import ImageHelper from "../Helpers/ImageHelper";

const Footer = () => {
  return (
    <>
      <footer className="footer-area footer-gap">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-4">
              <div id="logo">
                <Link to="/">
                  <img
                    draggable="false"
                    src={ImageHelper.Logo}
                    width="240"
                    height="90"
                    alt=""
                    title="TZ Creation - HOME | Graphic Design | Web Dev"
                    style={{ filter: "invert(1)" }}
                  />
                </Link>
              </div>
              <p className="footer-desc">
                Providing excellent solutions with great ideas and visions
                bringing them to fruition all while maximizing customer
                satisfaction and minimizing costs associated with developing and
                establishing brands.
              </p>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6  nav__links">
                  <div className="single-footer-widget">
                    <h4>Company</h4>
                    <ul className="footer-menu">
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/about">About</Link></li>
                      <li><Link to="/#services">Services</Link></li>
                      <li><Link to="/portfolio">Portfolio</Link></li>
                      {/* <li onClick={() => navigate("/case-study")}>
                        Case Studies
                      </li> */}
                      <li><Link to="/packages">Packages</Link></li>
                    </ul>
                  </div>
                </div>

                <div className="col-sm-6 col-md-6 col-lg-6 usedful_inks">
                  <div className="single-footer-widget">
                    <h4>Legal</h4>
                    <ul className="footer-menu">
                      {/* <li onClick={() => navigate("/under-construction")}>
                        Partners
                      </li> */}
                      {/* <li onClick={() => navigate("/careers")}>Careers</li> */}
                      <li>
                        <Link to="/disclaimer">Disclaimer</Link>
                      </li>
                      <li>
                        <Link to="/terms-and-conditions">Terms & Conditions</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/refund-policy">Refund Policy</Link>
                      </li>
                      <li>
                        <Link to="/non-disclosure-agreement">NDA</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-4" align="center">
              <div className="single-footer-widget">
                <h4>Newsletter</h4>
                <p>Stay updated with our latest trends</p>
                <div className="" id="mc_embed_signup">
                  <form
                    target="_blank"
                    action="https://tzcreation.us4.list-manage.com/subscribe/post?u=4b5641c6c662022062c00c2c4&amp;id=bdd2dafd56"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    className="validate"
                    // target="_blank"
                    noValidate
                  >
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        defaultValue=""
                        name="EMAIL"
                        placeholder="Enter Email Address"
                        // onFocus="this.placeholder = ''"
                        // onBlur="this.placeholder = 'Enter Email Address '"
                        required
                      />
                      <div className="input-group-btn">
                        <button
                          className="btn btn-default"
                          type="submit"
                          aria-label="Subscribe to newsletter"
                        >
                          <span className="lnr lnr-arrow-right"></span>
                        </button>
                      </div>
                      <div className="info"></div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="single-footer-widget mt-4">
                <h4>Stay connected with us</h4>
              </div>
              <div className="d-flex justify-content-center">
                <a
                  href="https://m.facebook.com/thetzcreation/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TZ Creation on Facebook (opens in a new tab)"
                >
                  <i
                    className="fa fa-facebook fa-2x fa-fw"
                    style={{ color: "white" }}
                  ></i>
                </a>
                <a
                  href="https://instagram.com/thetzcreation"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TZ Creation on Instagram (opens in a new tab)"
                >
                  <i
                    className="fa fa-instagram fa-2x fa-fw"
                    style={{ color: "white" }}
                  ></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/tzcreation/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TZ Creation on LinkedIn (opens in a new tab)"
                >
                  <i
                    className="fa fa-linkedin  fa-2x fa-fw"
                    style={{ color: "white" }}
                  ></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 mt-50" align="center">
            <div className="single-footer-widget">
              <p className="footer-text">
                Copyright &copy; {new Date().getFullYear()} All
                rights reserved by{" "}
                <strong style={{ color: "white" }}>
                  <Link to="/" style={{ color: "inherit" }}>
                    TZ Creation
                  </Link>
                </strong>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
